import clsx from "clsx"
import { forwardRef } from "react"

import { useSidePanelContent } from "@organisms/SidePanel/SidePanelContent/SidePanelContent.context"

import styles from "./SidePanelPanel.module.scss"
import type { SidePanelPanelProps } from "./SidePanelPanel.types"

function SidePanelPanel(props: SidePanelPanelProps, ref: React.Ref<HTMLDivElement>) {
    const { children, className, ...rest } = props
    const { hasFilePreview } = useSidePanelContent()

    return (
        <div
            ref={ref}
            className={clsx(
                styles.base,
                {
                    [styles.hasFilePreview]: hasFilePreview,
                },
                className,
            )}
            {...rest}
        >
            {children}
        </div>
    )
}

export default forwardRef(SidePanelPanel)
